import ScreenSendEmail from 'screens/SendEmail';
import { SEND_EMAIL } from 'routes/paths';

const sendEmailForm = [
  {
    path: SEND_EMAIL.FORM,
    name: 'SendEmailForm',
    component: ScreenSendEmail,
    loginRequired: true,
    allowPermissions: [],
  },
];

export default sendEmailForm;
